import metabaseProvider from "@/services/analytics/providers/metabase/provider";

const defaultAnalyticsProvider = metabaseProvider;

export default defaultAnalyticsProvider;
